import { Icon, iconNames } from 'shared_DEPRECATED/components/Icon';

import { useDeleteGoal } from 'features/goal';

import { ButtonIcon } from 'shared/components/Button';

type TGoalDeleteButton = {
  goalId: string;
  columnId: string;
};

export const GoalDeleteButton = ({ goalId, columnId }: TGoalDeleteButton) => {
  const { onDeleteGoalClick } = useDeleteGoal({ goalId, columnId });

  return (
    <ButtonIcon
      aria-label="delete goal"
      onClick={onDeleteGoalClick}
      size="md"
      variant="outline"
    >
      <Icon
        name={iconNames.binFilled}
        width="16px"
        height="18px"
        fill="var(--fgPrimary)"
      />
    </ButtonIcon>
  );
};
